package com.schoolconnect.app.feature.placeholder

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppCard
import com.schoolconnect.app.designsystem.AppOutlinedButton

private val PlaceholderBackground = Color(0xFFF8FAFC)
private val PlaceholderSurface = Color(0xFFFFFFFF)
private val PlaceholderPrimary = Color(0xFF2563EB)
private val PlaceholderText = Color(0xFF111827)
private val PlaceholderMuted = Color(0xFF6B7280)
private val PlaceholderBorder = Color(0xFFE5E7EB)

/** Honest staged state for routes whose production screen is not wired yet. */
@Composable
fun FeaturePlaceholderScreen(
    title: String,
    description: String,
    onBack: () -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(PlaceholderBackground)
            .padding(horizontal = 24.dp, vertical = 24.dp),
        verticalArrangement = Arrangement.spacedBy(24.dp)
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Text(text = "Home  /  $title", color = PlaceholderMuted, fontSize = 12.sp)
            Text(text = title, color = PlaceholderText, fontSize = 28.sp, fontWeight = FontWeight.SemiBold)
            Text(text = description, color = PlaceholderMuted, fontSize = 14.sp)
        }

        AppCard(modifier = Modifier.fillMaxWidth(), containerColor = PlaceholderSurface) {
            Column(
                modifier = Modifier.padding(24.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                Text(text = "Screen in progress", color = PlaceholderText, fontSize = 20.sp, fontWeight = FontWeight.SemiBold)
                Text(
                    text = "This destination is reserved for the $title workflow. The production data view and actions are being connected to the REST contract.",
                    color = PlaceholderMuted,
                    fontSize = 14.sp
                )
                Text(text = "No records or actions are available here yet.", color = PlaceholderPrimary, fontSize = 14.sp)
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.End,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    AppOutlinedButton(
                        onClick = onBack,
                        border = BorderStroke(1.dp, PlaceholderBorder)
                    ) {
                        Icon(imageVector = Icons.AutoMirrored.Filled.ArrowBack, contentDescription = null)
                        Spacer(modifier = Modifier.width(8.dp))
                        Text(text = "Back to dashboard")
                    }
                }
            }
        }
    }
}
